import { render } from "./ContextItem.vue?vue&type=template&id=5fb8f82c"
import script from "./ContextItem.vue?vue&type=script&lang=js"
export * from "./ContextItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__